import Link from "next/link";
import React from "react";

const CTASection = () => {
  return (
    <div
      className="group relative animate-fade-in max-w-6xl mx-auto flex justify-center items-center mb-32"
      style={{ animationDelay: "0.7s" }}
    >
      <div className="w-full relative rounded-3xl group-hover:border-purple-400/40 transition-all duration-500 p-8 md:p-12">
        <div className="text-center">
          <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">
            Take Control of Your Day
          </h3>
          <p className="text-gray-400 max-w-2xl mx-auto mb-6">
            Stay organized, focused, and in control with a simple all-in-one
            space for your tasks, finances, and daily planning.
          </p>
          <Link href={"/login"} className="px-8 py-3 bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-500 hover:to-purple-600 text-white font-semibold rounded-full transition-all duration-300 hover:shadow-lg hover:shadow-purple-600/50">
            Start Your Productivity Journey
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CTASection;
